import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DashboardModeContextType {
    isCreationMode: boolean;
    setIsCreationMode: (value: boolean) => void;
}

const DashboardModeContext = createContext<DashboardModeContextType>({
    isCreationMode: false,
    setIsCreationMode: () => {},
});

export const useDashboardMode = () => useContext(DashboardModeContext);

interface DashboardModeProviderProps {
    children: ReactNode;
}

export const DashboardModeProvider: React.FC<DashboardModeProviderProps> = ({ children }) => {
    const [isCreationMode, setIsCreationMode] = useState(false);

    return (
        <DashboardModeContext.Provider value={{ isCreationMode, setIsCreationMode }}>
            {children}
        </DashboardModeContext.Provider>
    );
};
